import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  open() {
    const popup = document.querySelector('.popup_policy')
    popup.classList.add('popup_visible')
  }

  close() {
    const popup = document.querySelector('.popup_policy')
    popup.classList.remove('popup_visible')
  }

  stop(e) {
    e.stopPropagation()
  }
}
